import { z } from 'zod/v4'
import type { Enums } from '../db/supabase.types.ts'
import { translatableFieldSchema, type TranslatableField } from '../lib/languages.ts'

export type TraitDisposition = Exclude<Enums<'trait_disposition'>, 'neutral'>
export type TraitAssignmentType = Enums<'trait_assignment_type_enum'>

// Payload for inserting a trait into the database.
export type TraitInsertPayload = {
  text: string
  disposition: TraitDisposition
  assignment_type?: TraitAssignmentType
  translations?: TranslatableField
}

export const pendingTraitSchema = z.object({
  id: z.string(),
  text: z.string(),
  disposition: z.enum(['positive', 'negative']),
  assignment_type: z.enum(['assigned', 'suggested']),
  translations: translatableFieldSchema,
})

// Data transfer object for traits that are not yet assigned to an object. They must exist in the database.
export type PendingTrait = z.infer<typeof pendingTraitSchema>

export const generatedTraitSchema = z.object({
  text: z.string(),
  disposition: z.enum(['positive', 'negative']),
  translations: translatableFieldSchema,
})

export type TraitEmbeddingTaskType = 'document' | 'query'

export type TraitEmbeddingResponseType =
  | {
      created_at: string
      embedding: number[]
      id: string
      text: string
    }
  | { embedding: number[] }

export type TranslatedTrait = {
  text: string
  translations: TranslatableField
}
